import { stringifyObjectValuesShallow, trackHeapEvent } from '@ratehub/base-ui';


/**
 * 'CC redirect to partner'-specific call to `trackHeapEvent`.
 *
 * @param {Object} params - parameters for the event
 * @param {string} params.referrerURL - URL of the referrer
 * @param {string} params.affiliateId - Id of the affiliate
 * @param {Object} params.additionalInfo - additional information for the event
 * @param {CreditCardShape} params.cardInfo - credit card
  */
function trackHeapCCRedirectEvent({ referrerURL, affiliateId, additionalInfo, cardInfo }) {
    const { name, bank, giftCardOffer, detailsURL, isMonetized, isSponsored } = cardInfo;

    trackHeapEvent('CC redirect to partner', {
        cardName: name,
        provider: bank,
        href: detailsURL,
        monetized: isMonetized.toString(),
        sponsored: isSponsored.toString(),
        ...(referrerURL && { refererUrl: referrerURL }),
        // refererUrl [sic] - preserve typo in property name
        ...(affiliateId && { affiliateId }),

        // Need to make sure only string values are passed to Heap
        // to simplify analytic tracking
        ...stringifyObjectValuesShallow({
            ...giftCardOffer,
            // this preserves the historic use of 'giftCardType' (vs. today’s preferred terminology `offerType`)
            ...(giftCardOffer?.offerType) && {
                giftCardType: giftCardOffer.offerType,
            },
        }),
        ...stringifyObjectValuesShallow(additionalInfo),
    });
}


export default trackHeapCCRedirectEvent;
